(() => {
  function scrollToCpbEditor() {
    let attempts = 0;

    const interval = window.setInterval(() => {
      const builder =
        document.querySelector('#product-builder') ||
        document.querySelector('[data-engine="shopify"][data-product-id]');

      if (builder) {
        const styles = window.getComputedStyle(builder);
        const rectangle = builder.getBoundingClientRect();

        const editorIsVisible =
          rectangle.height > 150 &&
          styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          Number.parseFloat(styles.opacity || '1') > 0;

        if (editorIsVisible) {
          window.clearInterval(interval);

          const header =
            document.querySelector('.shopify-section-header-sticky') ||
            document.querySelector('.header-wrapper');

          const headerHeight = header
            ? header.getBoundingClientRect().height
            : 80;

          const scrollPosition =
            window.scrollY +
            rectangle.top -
            headerHeight -
            20;

          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
      }

      attempts += 1;

      if (attempts >= 60) {
        window.clearInterval(interval);
      }
    }, 150);
  }

  document.addEventListener(
    'click',
    (event) => {
      const personalizeButton =
        event.target.closest('.personalize-it--js');

      if (personalizeButton) {
        window.setTimeout(scrollToCpbEditor, 100);
      }
    },
    true
  );
})();
